import type { WamFile } from "@workadventure/map-editor";
import { MoveTileLayerCommand } from "@workadventure/map-editor";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";

export class MoveTileLayerFrontCommand extends MoveTileLayerCommand implements FrontCommandInterface {
    private readonly oldIndex: number;

    constructor(
        wamFile: WamFile,
        layerId: number,
        newIndex: number,
        commandId: string | undefined,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, layerId, newIndex, commandId);
        this.oldIndex = MoveTileLayerFrontCommand.getFlatTileIndex(gameMapFrontWrapper, layerId);
    }

    public async execute(): Promise<void> {
        await super.execute();
        this.gameMapFrontWrapper.moveTileLayerById(this.layerId, this.newIndex);
    }

    public getUndoCommand(): MoveTileLayerFrontCommand {
        return new MoveTileLayerFrontCommand(
            this.wamFile,
            this.layerId,
            this.oldIndex,
            undefined,
            this.gameMapFrontWrapper,
        );
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorMoveTileLayer(this.commandId, this.layerId, this.newIndex);
    }

    private static getFlatTileIndex(gameMapFrontWrapper: GameMapFrontWrapper, layerId: number): number {
        const flatLayers = gameMapFrontWrapper.getFlatLayers();
        const flatIndex = flatLayers.findIndex((flat) => flat.type === "tilelayer" && flat.id === layerId);
        if (flatIndex === -1) {
            return 0;
        }
        return flatLayers.slice(0, flatIndex).filter((flat) => flat.type === "tilelayer").length;
    }
}
